import { patch } from "api"

export interface SmartFieldPlacement {
  align?: "center" | "left" | "right"
  font_size?: number
  height: number
  key: string
  page: number
  width: number
  x: number
  y: number
}

export const saveSmartFieldPlacements = async ({
  path,
  placements,
  sourcePdfKey,
}: {
  path: string
  placements: SmartFieldPlacement[]
  sourcePdfKey: string
}) => {
  return patch<{ errors?: string[] }>(path, {
    smart_field_placements: placements,
    source_pdf_key: sourcePdfKey,
  })
}
